"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransferRecipientShops = exports.getShopsV2 = exports.getShops = exports.createShop = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _shops = require("@module/shops");

var _utils = require("@package/utils");

var _request = _interopRequireDefault(require("@package/request"));

var _dialog = require("@package/dialog");

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _slice = require("../slice");

var getShops = function getShops(params) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result, shops;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Получение списка магазинов'
              });
              _context.next = 4;
              return dispatch((0, _slice.getShopsRequestAction)());

            case 4:
              _context.next = 6;
              return (0, _request["default"])({
                url: '/shops',
                method: 'get',
                params: params
              });

            case 6:
              result = _context.sent;
              shops = result['data'].filter(function (shop) {
                return shop['status'] === 'Active';
              });
              return _context.abrupt("return", dispatch((0, _slice.getShopsRequestSuccessAction)(shops)));

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return", void 0);

            case 15:
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при получении списка магазинов'
              });
              dispatch((0, _slice.getShopsRequestFailAction)(_context.t0));
              dispatch(notifications.pushFail(_context.t0['data']));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getShops = getShops;

var getShopsV2 = function getShopsV2(params) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(dispatch) {
      var result, shops;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Получение списка магазинов'
              });
              _context2.next = 4;
              return dispatch((0, _slice.getShopsRequestAction)());

            case 4:
              _context2.next = 6;
              return (0, _request["default"])({
                url: '/v2/shops',
                method: 'get',
                params: params
              });

            case 6:
              result = _context2.sent;
              shops = result['data'].filter(function (shop) {
                return shop['status']['type'] === 'Active';
              });
              return _context2.abrupt("return", dispatch((0, _slice.getShopsRequestSuccessAction)(shops)));

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);

              if (!(_context2.t0 instanceof _errors.UnauthorizedError)) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 15:
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при получении списка магазинов'
              });
              dispatch((0, _slice.getShopsRequestFailAction)(_context2.t0));
              dispatch(notifications.pushFail(_context2.t0['data']));

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getShopsV2 = getShopsV2;

var createShop = function createShop(data) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(dispatch) {
      var _yield$request, shopResult, count, shop, notExit, _yield$request2, items;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на создание магазина'
              });
              dispatch((0, _slice.createShopRequestAction)());
              _context3.next = 5;
              return (0, _request["default"])({
                url: '/shops',
                method: 'post',
                data: {
                  name: data['name'],
                  webSite: data['isNotWebSite'] ? null : data['webSite'],
                  demoMode: data['demoMode'] || false,
                  supportEmail: data['supportEmail'],
                  supportPhone: data['supportPhone'].replace(/[^+\d]/g, '')
                }
              });

            case 5:
              _yield$request = _context3.sent;
              shopResult = _yield$request.data;
              count = 0;
              shop = null;
              notExit = true;

            case 10:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос на созданный магазин с id: ' + shopResult['externalId']
              });
              ++count;
              _context3.next = 14;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 14:
              _context3.next = 16;
              return (0, _request["default"])({
                url: "/shops",
                method: 'get',
                params: {
                  externalId: shopResult['externalId']
                }
              });

            case 16:
              _yield$request2 = _context3.sent;
              items = _yield$request2.data;

              if (items.length > 0) {
                if (items[0]['externalId'] === shopResult['externalId']) {
                  shop = items[0];
                  notExit = false;
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context3.next = 21;
                break;
              }

              throw {
                data: {
                  code: '1.1.1',
                  message: 'Время ожидания вышло'
                }
              };

            case 21:
              if (notExit) {
                _context3.next = 10;
                break;
              }

            case 22:
              dispatch((0, _slice.createShopRequestSuccessAction)());
              dispatch((0, _shops.createShopAction)(shop));
              dispatch((0, _dialog.closeDialog)('create-shop'));
              dispatch(notifications.pushSuccess('Магазин успешно создан'));
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Магазин успешно создан'
              });
              _context3.next = 36;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](0);

              if (!(_context3.t0 instanceof _errors.UnauthorizedError)) {
                _context3.next = 33;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 33:
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании магазина'
              });
              dispatch((0, _slice.createShopRequestFailAction)(_context3.t0['data']));
              dispatch(notifications.pushFail(_context3.t0['data']));

            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 29]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.createShop = createShop;

var getTransferRecipientShops = function getTransferRecipientShops(params) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос магазинов, доступных для перевода средств'
              });
              dispatch((0, _slice.getTransferRecipientRequestAction)());
              _context4.next = 5;
              return (0, _request["default"])({
                url: '/shops',
                method: 'get',
                params: {
                  shopId: params['shops']
                }
              });

            case 5:
              result = _context4.sent;
              dispatch((0, _slice.getTransferRecipientRequestSuccessAction)(result['data']));
              _context4.next = 16;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);

              if (!(_context4.t0 instanceof _errors.UnauthorizedError)) {
                _context4.next = 13;
                break;
              }

              return _context4.abrupt("return", void 0);

            case 13:
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при получении списка магазинов, доступных для перевода средств'
              });
              dispatch((0, _slice.getTransferRecipientRequestFailAction)(_context4.t0['data']));
              dispatch(notifications.pushFail(_context4.t0['data']));

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getTransferRecipientShops = getTransferRecipientShops;